import React from 'react';
import PropTypes from 'prop-types';

import EditableTitle from './EditableTitle';
import EditableDescription from './EditableDescription';
import EditableHomePageLink from './EditableHomePageLink';
import i18n from '../../../../shared/locales/no.json';

export default function EditableInfo({ profile, onUpdateField }) {
    return (
        <section className="panel">
            <EditableTitle
                id={profile.id}
                name="companyName"
                onUpdate={onUpdateField}
                text={profile.companyName}
            />
            <EditableDescription
                companyName={profile.companyName}
                header={i18n.about.title}
                help={i18n.about.help}
                id={profile.id}
                maxLength={200}
                name="description"
                onUpdate={onUpdateField}
                text={profile.description}
            />
            <EditableHomePageLink
                id={profile.id}
                name="homePageUrl"
                onUpdate={onUpdateField}
                text={profile.homePageUrl}
            />
        </section>
    );
}

EditableInfo.propTypes = {
    profile: PropTypes.object.isRequired,
    onUpdateField: PropTypes.func.isRequired,
};
